// extracted by mini-css-extract-plugin
module.exports = {"bodyMinHeight":"_b538845f"};